// Gallery image data structure
// Add your gallery images here
export const galleryImages = [
  {
    id: 1,
    src: '/gallery/_DSC0306.jpeg',
    alt: 'Live performance'
  },
  {
    id: 2,
    src: '/gallery/_DSC0304.jpeg',
    alt: 'Live performance'
  },
  {
    id: 3,
    src: '/gallery/_DSC0303.jpeg',
    alt: 'Live performance'
  },
  {
    id: 4,
    src: '/gallery/_DSC0244.jpeg',
    alt: 'Live performance'
  },
  {
    id: 5,
    src: '/gallery/_DSC0237.jpeg',
    alt: 'Live performance'
  }
];
